import { useTitle as useVuePageTitle } from 'vue-page-title'

export const useTitle = () => {
  const { setTitle, title } = useVuePageTitle()

  return {
    prefixTitle(text) {
      const prefix = text ? `${text} – ` : ''
      setTitle(prefix + title.value)
    },
  }
}
